import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-file",
  "use": "icon-file-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-file\"><path d=\"M286.7 524.9h450.8V589H286.7zM286.7 661h450.8v64.1H286.7z\" /><path d=\"M851.3 405.3v-70.5L659.1 142.7h-96.4v0.1H187.8c-8.8 0-16 7.2-16 16V865c0 8.8 7.2 16 16 16h647.5c8.8 0 16-7.2 16-16V405.3z m-189.1-169l98.3 98.3h-98.3v-98.3z m125.1 580.6H235.9v-610h326.9l35.4-0.1v153.5c0 21.2 17.2 38.4 38.4 38.4h150.7V816.9z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol